<template>
  <v-card v-if="notBilled">
    <v-card-title>
      Faturas
      <v-spacer></v-spacer>
      <v-checkbox
        v-model="projected_by_date"
        label="Apenas Projeção + 7 dias"
      ></v-checkbox>
      <v-checkbox
        v-model="only_projected"
        label="Apenas com Projeção"
      ></v-checkbox>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="notBilled"
      :loading="loadingNotBilled"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.consumer_unit }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.projected_issued_at | formatDate }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          <v-tooltip
            v-if="(isAdmin || isFinancial) && props.item.unique_billing"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="green darken-4">task_alt</v-icon>
            </template>
            <span>Conta unificada</span>
          </v-tooltip>
          <v-tooltip
            v-else-if="(isAdmin || isFinancial) && !props.item.unique_billing"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="error">highlight_off</v-icon>
            </template>
            <span>A conta não é unificada</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.uc_billing_competence_start | formatCompetence }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          {{ props.item.uc_billing_competence_end | formatCompetence }}
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          <v-chip
            :color="props.item.uc_status | formatUCStatusColor"
            text-color="white"
          >
            {{ props.item.uc_status | formatUCStatus }}
          </v-chip>
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          <v-tooltip
            v-if="permissions.download_bill && props.item.baixou_conta.done"
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" icon @click="downloadResumePdf(props.item)">
                <v-icon :color="props.item.bill_status ? 'orange' : 'blue'"
                  >list_alt</v-icon
                >
              </v-btn>
            </template>
            <span
              >Conta da concessionária
              {{ props.item.bill_status | formatBillStatus }}</span
            >
          </v-tooltip>
          <v-tooltip
            v-else-if="
              (isAdmin || isFinancial || isPartnerManagement) &&
              !props.item.baixou_conta.done &&
              props.item.bill_status
            "
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="orange">{{
                props.item.bill_status | formatBillIcon
              }}</v-icon>
            </template>
            <span>{{ props.item.bill_status | formatBillStatus }}</span>
          </v-tooltip>
          <v-tooltip
            v-else-if="
              (isAdmin || isFinancial || isPartnerManagement) &&
              !props.item.baixou_conta.done
            "
            bottom
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" color="grey">error_outline</v-icon>
            </template>
            <span>Não baixada</span>
          </v-tooltip>
        </td>
        <td class="text-xs-center text-md-center text-lg-center">
          <v-tooltip v-if="permissions.upload_bill" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-2 pl-2"
                color="blue"
                v-if="
                  !loadingRequest &&
                  !props.item.baixou_conta.done &&
                  props.item.bill_status !== 'withheld'
                "
                @click.prevent="onPickFileBill(props.item)"
                >upload_file</v-icon
              >
              <v-icon v-else class="ml-2 pl-2" color="grey lighten-2"
                >upload_file</v-icon
              >
              <input
                style="display: none"
                @change="detectFiles($event)"
                accept="application/pdf"
                type="file"
                ref="billFile"
              />
            </template>
            <span>Upload da conta</span>
          </v-tooltip>
          <v-tooltip v-if="permissions.invoice_by_spreadsheet" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-2 pl-2"
                color="blue"
                v-if="!loadingRequest && props.item.last_report_data_at"
                @click="openBillModal(props.item)"
              >
                view_list</v-icon
              >
              <v-icon v-else class="ml-2 pl-2" color="grey lighten-2"
                >view_list</v-icon
              >
            </template>
            <span>Faturar por planilha</span>
          </v-tooltip>

          <v-tooltip v-if="permissions.invoice_by_xml" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-2 pl-2"
                color="blue"
                v-if="!loadingRequest && props.item.last_report_data_at"
                @click="billNotBilledUc(props.item, 'xml', null, null)"
              >
                code</v-icon
              >
              <v-icon v-else class="ml-2 pl-2" color="grey lighten-2"
                >code</v-icon
              >
            </template>
            <span>Faturar por XML</span>
          </v-tooltip>

          <v-tooltip v-if="isAdmin || isFinancial" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                class="ml-2 pl-2"
                color="grey"
                v-if="isAdmin || isFinancial"
                @click.prevent="goToCustomerCare(props.item.consumer_unit)"
                >settings_accessibility</v-icon
              >
            </template>
            <span>Ir para tela de Atendimento.</span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:no-data>
        <v-alert :value="true" color="error" icon="warning">
          Sem dados para exibir.
        </v-alert>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
    <v-snackbar :color="color" top v-model="snackbar" dark>
      <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
      <div>{{ snackMessage }}</div>
      <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
    </v-snackbar>
    <billing-modal
      :key="updateComponent"
      :showDialog="showBillingModal"
      :closeBillingModal="closeModal"
      @checkBillingOptition="checkBillingOptition"
      @showSnack="showSnack"
    />
  </v-card>
</template>

<script>
import { firestorage } from "@/firebase/firestorage";
import moment from "moment";
import { mapState } from "vuex";
import { billBySpreadsheet, billByXML } from "../../services/billing";
import { uploadBill } from "../../services/billing_list";
import { getPermission } from "../../services/permissions";
import BillingModal from "./BillingModal.vue";

export default {
  components: {
    BillingModal,
  },

  data() {
    return {
      search: "",
      headers: [
        {
          text: "Unidade Consumidora",
          align: "center",
          value: "consumer_unit",
        },
        {
          text: "Projeção de emissão",
          value: "projected_issued_at",
          align: "center",
        },
        { text: "Conta Unificada", value: "unique_billing", align: "center" },
        {
          text: "Início de Competência",
          value: "uc_billing_competence_start",
          align: "center",
        },
        {
          text: "Fim de Competência",
          value: "uc_billing_competence_end",
          align: "center",
        },
        { text: "Status da UC", value: "uc_status", align: "center" },
        { text: "Conta", align: "center" },
        { text: "Ações", align: "center" },
      ],
      pag: {
        sortBy: "projected_issued_at",
        rowsPerPage: 20,
      },
      projected_by_date: false,
      only_projected: false,
      notBilled: null,
      color: null,
      snackbar: false,
      snackMessage: null,
      bill_upload_bl_item: null,
      loadingRequest: false,
      showBillingModal: false,
      selectedBill: null,
      updateComponent: 1,
    };
  },

  watch: {
    only_projected() {
      this.filterNotBilled();
    },
    projected_by_date() {
      this.filterNotBilled();
    },
    notBilledUCs() {
      this.filterNotBilled();
    },
  },

  computed: {
    ...mapState("billing", ["loadingNotBilled", "notBilledUCs"]),
    ...mapState(["user", "permissions"]),

    isAdmin() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("admin") >= 0;
    },

    isFinancial() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("financial") >= 0;
    },

    isPartnerManagement() {
      let currentUserGroups = this.user.group.toString();
      return currentUserGroups.indexOf("partner_management") >= 0;
    },
  },

  filters: {
    formatDate: (date) => {
      if (!date) return "-";
      const splitDate = date.split("-");
      return `${splitDate[2]}/${splitDate[1]}/${splitDate[0]}`;
    },

    formatCompetence: (competence) => {
      if (!competence) return "-";
      const splitCompetence = competence.split("-");
      return `${splitCompetence[1]}/${splitCompetence[0]}`;
    },

    formatBillStatus(value) {
      if (value === "withheld") {
        return "Conta retida";
      } else if (value === "low_income") {
        return "Baixa renda";
      } else if (value === "no_contract") {
        return "Sem contrato";
      } else {
        return value;
      }
    },

    formatBillIcon(value) {
      if (value === "withheld") {
        return "inventory";
      } else if (value === "low_income") {
        return "currency_exchange";
      } else if (value === "no_contract") {
        return "gpp_bad";
      } else {
        return "info";
      }
    },
  },

  methods: {
    snack(message, color) {
      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },

    filterNotBilled() {
      const today = moment();
      const projected_issued_at = today
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.notBilled = this.notBilledUCs
        .filter((uc) => (this.only_projected ? uc.projected_issued_at : true))
        .filter((uc) =>
          this.projected_by_date
            ? !uc.projected_issued_at ||
              uc.projected_issued_at < projected_issued_at
            : true,
        );
    },

    goToCustomerCare(consumer_unit) {
      this.$router.push({
        path: "atendimento/?installation_number=" + consumer_unit,
      });
    },

    async onPickFileBill(bl_item) {
      try {
        const permission = await getPermission("upload_bill", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      this.bill_upload_bl_item = bl_item;
      //this.$refs.billFile.click()
      const fileChooser = document.createElement("input");
      fileChooser.setAttribute("type", "file");
      fileChooser.setAttribute("accept", "application/pdf");
      fileChooser.addEventListener("change", this.detectFiles);
      fileChooser.click();
    },

    async detectFiles(e) {
      this.loadingRequest = true;
      let fileList = e.target.files || e.dataTransfer.files;
      Array.from(Array(fileList.length).keys()).map(async (x) => {
        console.log(fileList[x]);
        let formData = new FormData();
        formData.append("bill", fileList[x]);
        formData.append(
          "bl_data",
          JSON.stringify({
            consumer_unit: this.bill_upload_bl_item.id,
            power_plant: this.bill_upload_bl_item.power_plant,
            competence: this.bill_upload_bl_item.competence,
            utility_company: this.bill_upload_bl_item.utility_company,
          }),
        );
        await uploadBill(formData)
          .then((res) => {
            console.log("Response:", res.data);
            this.snack(res.data, "green");
          })
          .catch((err) => {
            console.error(err);
            console.error(err && err.response ? err.response.data : "");
            this.snack(
              "Erro ao fazer upload!" + err && err.response
                ? err.response.data
                : "",
              "red",
            );
          });
      });
      this.loadingRequest = false;
    },

    async downloadResumePdf(item) {
      try {
        const permission = await getPermission("download_bill", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          return false;
        }
      } catch (err) {
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }

      const path = `bills/${item.consumer_unit}_${item.competence}.pdf`;
      const resumeRef = firestorage.ref(path);
      resumeRef
        .getDownloadURL()
        .then((url) => {
          window.open(url, "_blank");
        })
        .catch((error) => {
          switch (error.code) {
            case "storage/object-not-found":
              this.snack("O arquivo não existe!", "red");
              break;

            case "storage/unauthorized":
              this.snack(
                "O usuário não tem permissão para acessar o objeto!",
                "red",
              );
              break;

            case "storage/canceled":
              this.snack("O usuário cancelou o upload!", "red");
              break;

            case "storage/unknown":
              this.snack("Ocorreu um erro inesperado!", "red");
              break;
            default:
              break;
          }
        });
    },

    async billNotBilledUc(notBilledUC, method, billing_data, unifiedOption) {
      try {
        this.loadingRequest = true;
        const permission = await getPermission("invoice_by_xml", this.user.id);

        if (!permission.data.has_permission) {
          this.snack("Usuário sem permissão para realizar essa ação", "red");
          this.loadingRequest = false;
          return false;
        }
      } catch (err) {
        this.loadingRequest = false;
        this.snack("Falha ao consultar permissão do usuário", "red");
        console.error("Falha ao consultar permissão", err);
        return false;
      }
      this.loadingRequest = true;
      const consumer_unit = notBilledUC.consumer_unit;
      const power_plant_id = notBilledUC.power_plant;
      const competence = notBilledUC.competence;
      const report_date = notBilledUC.last_report_data_at || null;
      const utility_company = notBilledUC.utility_company;

      this.snack("Unidade consumidora sendo faturada por XML. Aguarde", "grey");

      if (method == "xml") {
        await billByXML(consumer_unit, power_plant_id, competence, report_date)
          .then(() => {
            this.snack("Unidade consumidora faturada por XML", "green");
          })
          .catch((error) => {
            switch (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              case "NO_PLANT_CONFIG":
                this.snack(
                  "Configurações da planta e competência não encontrada",
                  "red",
                );
                break;
              case "COBRA_CUSTO_DISP_NOT_FOUND":
                this.snack(
                  "Identificação da cobrança de custo de disponibilidade não encontrada",
                  "red",
                );
                break;
              case "ALREADY_EXISTS":
                this.snack("Essa fatura já existe", "red");
                break;
              case "UC_NOT_FOUND":
                this.snack("Unidade consumidora não encontrada", "red");
                break;
              case "WRONG_PLANT":
                this.snack(
                  "A planta da unidade consumidora não coincide com a da conta",
                  "red",
                );
                break;
              case "NO_FIXED_RATE":
                this.snack("Tafira fixa não identificada", "red");
                break;
              case "NO_PERCENTAGE_DISCOUNT":
                this.snack("Percentual de desconto não identificado", "red");
                break;
              case "USER_NOT_FOUND":
                this.snack("Usuário não encontrado", "red");
                break;
              case "ERROR_UPDATE_REFERRAL_BALANCE":
                this.snack("Erro ao atualizar bônus de indicação.", "red");
                break;
              case "ERROR_UPDATE_ACCOUNT_BALANCE":
                this.snack(
                  "Erro ao atualizar bônus da unidade consumidora",
                  "red",
                );
                break;
              case "ERROR_UPDATE_USER_ACCOUNT_BALANCE":
                this.snack("Erro ao atualizar bônus do usuário", "red");
                break;
              case "ERROR_UPDATE_COUPON_BALANCE":
                this.snack(
                  "Erro ao atualizar coupon_balance da unidade consumidora",
                  "red",
                );
                break;
              case "BILLING_ALREADY_EXISTS":
                this.snack("Fatura já existe", "red");
                break;
              case "USER_OR_UC_NOT_FOUND":
                this.snack("Cliente ou UC não encontrado", "red");
                break;
              case "CANCELED_CONSUMER_UNIT":
                this.snack("UC cancelada", "red");
                break;
              case "PAST_BILLING_COMPETENCE_END":
                this.snack("billing_competence_end > competence", "red");
                break;
              case "NOT_PAST_PROJECTION_DATE":
                this.snack("Não passou 10 dias da data de projeção", "red");
                break;
              case "CEMIG_NOT_CHARGED":
                this.snack("Não faturado pela Cemig", "red");
                break;
              case "GD_INFO_NOT_FOUND":
                this.snack("Dados não encontrados na XML", "red");
                break;
              default:
                this.snack("Erro ao realizar o faturamento por XML", "red");
                break;
            }
          });
      } else if (method == "spreadsheet") {
        await billBySpreadsheet(
          consumer_unit,
          power_plant_id,
          competence,
          report_date,
          utility_company,
          billing_data,
        )
          .then(() => {
            if (unifiedOption === "yes") {
              this.snack(
                "Unidade consumidora faturada unificada por planilha",
                "green",
                "top",
              );
            } else {
              this.snack(
                "Unidade consumidora faturada por planilha",
                "green",
                "top",
              );
            }
          })
          .catch((error) => {
            switch (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              case "NO_PLANT_CONFIG":
                this.snack(
                  "Configurações da planta e competência não encontrada",
                  "red",
                );
                break;
              case "COBRA_CUSTO_DISP_NOT_FOUND":
                this.snack(
                  "Identificação da cobrança de custo de disponibilidade não encontrada",
                  "red",
                );
                break;
              case "ALREADY_EXISTS":
                this.snack("Essa fatura já existe", "red");
                break;
              case "UC_NOT_FOUND":
                this.snack("Unidade consumidora não encontrada", "red");
                break;
              case "WRONG_PLANT":
                this.snack(
                  "A planta da unidade consumidora não coincide com a da conta",
                  "red",
                );
                break;
              case "NO_FIXED_RATE":
                this.snack("Tafira fixa não identificada", "red");
                break;
              case "NO_PERCENTAGE_DISCOUNT":
                this.snack("Percentual de desconto não identificado", "red");
                break;
              case "USER_NOT_FOUND":
                this.snack("Usuário não encontrado", "red");
                break;
              case "ERROR_UPDATE_REFERRAL_BALANCE":
                this.snack("Erro ao atualizar bônus de indicação", "red");
                break;
              case "ERROR_UPDATE_ACCOUNT_BALANCE":
                this.snack(
                  "Erro ao atualizar bônus da unidade consumidora",
                  "red",
                );
                break;
              case "ERROR_UPDATE_USER_ACCOUNT_BALANCE":
                this.snack("Erro ao atualizar bônus do usuário", "red");
                break;
              case "ERROR_UPDATE_COUPON_BALANCE":
                this.snack(
                  "Erro ao atualizar coupon_balance da unidade consumidora",
                  "red",
                );
                break;
              case "BILLING_ALREADY_EXISTS":
                this.snack("Fatura já existe", "red");
                break;
              case "USER_OR_UC_NOT_FOUND":
                this.snack("Cliente ou UC não encontrado", "red");
                break;
              case "CANCELED_CONSUMER_UNIT":
                this.snack("UC cancelada", "red");
                break;
              case "PAST_BILLING_COMPETENCE_END":
                this.snack("billing_competence_end > competence", "red");
                break;
              case "NOT_PAST_PROJECTION_DATE":
                this.snack("Não passou 10 dias da data de projeção", "red");
                break;
              case "CEMIG_NOT_CHARGED":
                this.snack("Não faturado pela Cemig", "red");
                break;
              case "GD_INFO_NOT_FOUND":
                this.snack("Dados não encontrados na planilha", "red");
                break;
              default:
                this.snack(
                  "Erro ao realizar o faturamento por planilha",
                  "red",
                );
                break;
            }
          });
      }

      this.loadingRequest = false;
    },

    openBillModal(item) {
      this.selectedBill = item;
      this.showBillingModal = true;
      this.updateComponent++;
    },

    closeModal() {
      this.selectedBill = null;
      this.showBillingModal = false;
    },

    showSnack(text, color) {
      this.snack(text, color);
    },

    checkBillingOptition(unifiedOption, billing_data) {
      if (unifiedOption === "yes") {
        this.billNotBilledUc(
          this.selectedBill,
          "spreadsheet",
          billing_data,
          unifiedOption,
        );
      } else {
        this.billNotBilledUc(
          this.selectedBill,
          "spreadsheet",
          null,
          unifiedOption,
        );
      }
      this.selectedBill = null;
      this.showBillingModal = false;
    },
  },
};
</script>
